exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-study {\n  background-color: #FBB917; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/shared/newchaining/newchaining.component.scss
// module id = ../../../../../src/app/shared/newchaining/newchaining.component.scss
// module chunks = main